const isInvalidDate = (date: Date) => Number.isNaN(date.getTime());
const isNotInvalidDate = (date: Date) => !isInvalidDate(date);

export const dateUtils = {
  isInvalidDate,
  isNotInvalidDate,
};

export const convertSecondsToHHMM = (totalSeconds: number): string => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.ceil((totalSeconds % 3600) / 60);
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
};
